import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/providers/AuthGuard';


const routes: Routes = [
  { path: 'home',  loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)  },
  { path: 'solutions',  loadChildren: () => import('./solutions/solutions.module').then(m => m.SolutionsModule)  },
  { path: 'contact',  loadChildren: () => import('./contact/contact.module').then(m => m.ContactModule)  },
  { path: 'company',  loadChildren: () => import('./about/about.module').then(m => m.AboutModule)  },
  { path: '', redirectTo:'home', pathMatch : 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
